export {
  now,
  timer,
  timerFlush
} from "./timer.js";

export {
  default as timeout
} from "./timeout.js";

export {
  default as interval
} from "./interval.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-timer/src/index.js
// module id = 74
// module chunks = 0